import { render, staticRenderFns } from "./AlertActivateTwoStepsAuthentication.vue?vue&type=template&id=276f1bd1"
import script from "./AlertActivateTwoStepsAuthentication.vue?vue&type=script&lang=js"
export * from "./AlertActivateTwoStepsAuthentication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports